/**
 * Минимальная fetch-обёртка API ВК-бота (копия подхода frontend-wiki).
 *
 * В dev: vite proxy /api → localhost:3000.
 * В prod: nginx vk.brasol.ru проксирует /api на общий backend —
 * same-origin, session-cookie fib.sid с domain=.brasol.ru общая с CRM.
 */

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: unknown,
    message: string,
  ) {
    super(message);
  }
}

async function request<T>(
  method: 'GET' | 'POST' | 'PATCH' | 'DELETE',
  path: string,
  body?: unknown,
): Promise<T> {
  const r = await fetch(`/api${path}`, {
    method,
    headers: body ? { 'Content-Type': 'application/json' } : {},
    credentials: 'include',
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!r.ok) {
    let parsed: unknown = null;
    try {
      parsed = await r.json();
    } catch {
      // not JSON
    }
    const msg =
      (parsed && typeof parsed === 'object' && 'message' in parsed
        ? String((parsed as { message: unknown }).message)
        : null) || `HTTP ${r.status}`;
    throw new ApiError(r.status, parsed, msg);
  }
  return (await r.json()) as T;
}

export const api = {
  get: <T>(path: string) => request<T>('GET', path),
  post: <T>(path: string, body?: unknown) => request<T>('POST', path, body),
  patch: <T>(path: string, body?: unknown) => request<T>('PATCH', path, body),
  delete: <T>(path: string) => request<T>('DELETE', path),
};

/** POST multipart (загрузка KML). */
export async function apiUpload<T>(path: string, formData: FormData): Promise<T> {
  const r = await fetch(`/api${path}`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!r.ok) {
    let msg = `HTTP ${r.status}`;
    try {
      const data = (await r.json()) as { message?: string };
      msg = data.message ?? msg;
    } catch {
      /* не JSON */
    }
    throw new ApiError(r.status, null, msg);
  }
  return (await r.json()) as T;
}
